<template>
  <Modal
    id="contact-warning"
    :modal="contactWarningModalRef"
    :steps="[{ component: ContactWarningModalContent, id: 'contact-warning', stepName: 'contact-warning' }]"
    :onExit="onClose"
  />
</template>

<script setup lang="ts">
import ContactWarningModalContent from '@/features/sessions/components/contact-warning-modal/contact-warning-modal-content/contact-warning-modal-content.vue'
import Modal from '@/features/ui/components/modal/modal.vue'
import { selectGetContactWarningModal } from '@/features/ui/store/modal/modal.selectors'
import type { ContactWarningModalType } from '@/features/ui/store/modal/modal.store'
import modalsStore from '@/features/ui/store/modal/modal.store'

const contactWarningModalRef = selectGetContactWarningModal(modalsStore)

function onClose() {
  console.log('onClose')
  modalsStore.updateModalAttachedData<ContactWarningModalType>('contact-warning', { moderationPiiMessageId: null })
}
</script>
